import React, { useEffect, useRef } from 'react';

export default function StepStammdaten({ wert = {}, onChange, antworten }) {
  const didPrefill = useRef(false);

  // Vorname/Nachname aus Step 1 vorbefüllen
  useEffect(() => {
    if (didPrefill.current) return;
    if (!wert.vorname && !wert.nachname) {
      const nameInfo = antworten?.name;
      if (nameInfo?.vorname || nameInfo?.nachname) {
        didPrefill.current = true;
        onChange({ ...wert, vorname: nameInfo.vorname ?? '', nachname: nameInfo.nachname ?? '' });
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setFeld(key, val) {
    onChange({ ...wert, [key]: val });
  }

  function handleCvUpload(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    onChange({ ...wert, cvDatei: { file, name: file.name, mime: file.type } });
  }

  return (
    <div className="ob-step-enter ob-stamm">
      <div className="ob-stamm-grid">
        <label className="ob-name-field">
          <span>Vorname</span>
          <input type="text" value={wert.vorname ?? ''} onChange={e => setFeld('vorname', e.target.value)} placeholder="Max" autoComplete="given-name" />
        </label>
        <label className="ob-name-field">
          <span>Nachname</span>
          <input type="text" value={wert.nachname ?? ''} onChange={e => setFeld('nachname', e.target.value)} placeholder="Mustermann" autoComplete="family-name" />
        </label>
        <label className="ob-name-field ob-stamm-full">
          <span>E-Mail</span>
          <input type="email" value={wert.email ?? ''} onChange={e => setFeld('email', e.target.value)} placeholder="max@beispiel.de" autoComplete="email" />
        </label>
        <label className="ob-name-field ob-stamm-full">
          <span>Telefon</span>
          <input type="tel" value={wert.telefon ?? ''} onChange={e => setFeld('telefon', e.target.value)} placeholder="+49 170 000 0000" autoComplete="tel" />
        </label>
        <label className="ob-name-field ob-stamm-street">
          <span>Straße</span>
          <input type="text" value={wert.strasse ?? ''} onChange={e => setFeld('strasse', e.target.value)} placeholder="Musterstraße" autoComplete="street-address" />
        </label>
        <label className="ob-name-field ob-stamm-hnr">
          <span>Hausnr.</span>
          <input type="text" value={wert.hausnummer ?? ''} onChange={e => setFeld('hausnummer', e.target.value)} placeholder="12a" />
        </label>
        <label className="ob-name-field ob-stamm-plz">
          <span>PLZ</span>
          <input type="text" value={wert.plz ?? ''} onChange={e => setFeld('plz', e.target.value)} placeholder="10115" autoComplete="postal-code" />
        </label>
        <label className="ob-name-field ob-stamm-ort">
          <span>Ort</span>
          <input type="text" value={wert.ort ?? ''} onChange={e => setFeld('ort', e.target.value)} placeholder="Berlin" />
        </label>
      </div>

      <div className="ob-stamm-cv">
        <span className="ob-stamm-cv-label">LEBENSLAUF</span>
        <label className={`ob-stamm-cv-card${wert.cvDatei ? ' ob-stamm-cv-card--aktiv' : ''}`}>
          <input type="file" accept="application/pdf" onChange={handleCvUpload} style={{ display: 'none' }} />
          <span className="ob-stamm-cv-title">
            {wert.cvDatei ? `✓  ${wert.cvDatei.name}` : '+ Lebenslauf als PDF hochladen'}
          </span>
          <span className="ob-stamm-cv-sub">
            {wert.cvDatei ? 'Klicken zum Ändern' : 'Erforderlich — CVFlow liest deinen bisherigen Lebenslauf ein'}
          </span>
        </label>
      </div>
    </div>
  );
}
